import 'react';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Link as Link$1 } from './Link.js';
import { LinkInspector } from './LinkInspector.js';
import { jsx } from '@emotion/react';

var Link = decorateComponent(Link$1, 'inline', {
  id: 'a',
  label: '링크',
  defaultProps: {
    to: 'https://ohou.se',
    openOption: 'sameTab'
  },
  disallowedAncestors: ['a', 'coupon', 'tabButton'],
  renderIcon: function renderIcon() {
    return jsx(BsLink45Deg, null);
  },
  renderInspector: LinkInspector
});

export { Link as default };
//# sourceMappingURL=index.js.map
